/*const fetcher = (url) => fetch(url).then(res => res.json())*/

const fetcher = async url => {
    const res = await fetch(url)

    if(res.ok) {
        return res.json()
    }

    return res.text().then(text => {throw new Error(text)})
}

export default fetcher